<template>
  <v-row no-gutters
    align-start
    justify-start
    fill-height>
    <v-col cols="12">
      <stereo-pair-main-image :image1="mainImage1" :image2="mainImage2"/>
    </v-col>
    <stereo-image-drawer :pairArray="stereoImagePairs" @changeSelect="changeSelect(image1, image2)"/>
  </v-row>
</template>

<script>
import stereoImageDrawer from "./StereoImageDrawer";
import stereoPairMainImage from "./StereoPairMainImage";
import { mapGetters } from "vuex";

export default {
  name: "stereoBrowserBody",
  components: {stereoImageDrawer, stereoPairMainImage},
  computed: {
     ...mapGetters(["stereoImagePairs", "stereoSelectedPair"]),
    mainImage1() {
      return this.stereoSelectedPair && this.stereoSelectedPair.image1;
    },
    mainImage2() {
      return this.stereoSelectedPair && this.stereoSelectedPair.image2;
    }
  }
}
</script>